// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__SF_IA","right":"styles_right__bndrS"};